<template>
  <el-dialog 
  center 
  title="" 
  :visible.sync="ddModalVisible" 
  :show-close="false"
  :custom-class="step == 2 ? 'dd-modal-warp dd-modal-warp-after': 'dd-modal-warp'"
  >
  <template v-if="!isError">
    <div class="modal-cont">
        <div class="cont" v-if="step == 1 && dingTalkStatus == 2">
          <div class="left">
            <h2>{{ $t('common.ddModalJoinHqTitle') }}</h2>
            <p>{{ $t('common.ddModalJoinHqSubtitle') }}</p>
            <span class="line"></span>
            <ul>
              <li class="light">{{ $t('common.ddModalBulletIndustry') }}</li>
              <li class="student">{{ $t('common.ddModalBulletSystem') }}</li>
              <li class="promote">{{ $t('common.ddModalBulletSales') }}</li>
            </ul>
          </div>
            <div class="right qrcode animate__animated animate__fadeIn">
              <div class="logo" v-if="env == 'dev'||env == 'test'"><img src="../assets/images/dingding/qrcode-test.jpeg" alt=""/></div>
              <div class="logo" v-else><img src="../assets/images/dingding/qrcode.jpeg" alt=""/></div>
              <div class="txt">{{ $t('common.ddModalScanToJoin') }}</div>
            </div>
        </div>
        <div class="cont after-bind" v-if="step == 2">
          <h2>{{ $t('common.ddModalTrainUnlockTitle') }}</h2>
          <div class="warp">
            <div class="left">
              <div class="qrcode animate__animated animate__fadeIn">
                <div class="logo"><img :src="trainData.qrcode_url" alt=""/></div>
                <div class="txt">{{ $t('common.ddModalMobileLearn') }}</div>
              </div>
            </div>
            <div class="right">
              <div class="qrcode animate__animated animate__fadeIn">
                <div class="logo"><img src="../assets/images/dingding/zhanwei.png" alt=""/></div>
                <div class="txt">{{ $t('common.ddModalDesktopLearn') }}</div>
                <div class="study-btn" @click="learingStaff(trainData.jump_url)">{{ trainData.train_status == '1' ? this.$t('app.auto_686_67ae8165'):this.$t('app.auto_687_479f10d7') }}</div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </template>
  <template v-else>
    <div class="modal-cont is-error">
      <div class="warp">
        <div class="error-img">
          <img src="../assets/images/dingding/error.png" alt=""/>
        </div>
        <div class="txt">{{ $t('common.ddModalSignupFailed') }}</div>
        </div>
    </div>
  </template>
    <div class="close" v-if="step == 2" @click="setModalVisible(false)">
      <img src="../assets/images/dingding/close.png" alt=""/>
    </div>
  </el-dialog>
</template>
<script>
import { queryUserDingStatus } from '@/api/login';
import { getBasicUrls } from '../util/config'

let timer = null;

export default {
  name: 'dd-modal',
  data(){
    return{
      showQRcode: false,
      isError: false,
      dingTalkStatus: 0,
      // 环境
      env: 'dev'
    }
  },
  props: {
    ddModalVisible: {
      type: Boolean,
      default: false
    },
    step: {
      type: Number,
      default: 1
    },
    trainData: {
      type: Object,
      default: () => {}
    }
  },
  created(){
    this.env = getBasicUrls().env;
    // 监听，父级状态发生变化时，需要执行
    // 需要加入部门
    // && this.dingTalkStatus == 2 // 非2的时候 可能会有培训学习弹框
    // train_status 2，6，99 需要培训学习
    const { ddModalVisible,step } = this;
    if(ddModalVisible && step == 1){
      this.dingTalkStatusTimer();
    } else {
      // 不需要加入部门
      if(timer) clearInterval(timer);
    }
  },
  mounted(){
    this.getUserDingStatus();
  },
  methods: {
    setModalVisible(val){
      // 调用父组件关闭事件
      clearInterval(timer);
      // this.props.setModalVisible(val)
      this.$emit('setModalVisible',val)
    },
    learingStaff(url){
      window.open(url)
    },
    dingTalkStatusTimer() {
      // 轮训 查询加入状态 每隔10秒
      if(timer) clearInterval(timer);
      timer = setInterval(() => {
        this.getUserDingStatus()
      }, 10 * 1000);
    },
    getUserDingStatus(){
      queryUserDingStatus().then(ret => {
          if (ret.code === 0) {
              if(ret.data){
                  // 钉钉绑定状态 0 正常 1 未绑定 2 未加入部门
                  this.dingTalkStatus = ret.data.dingTalkStatus
                  // this.props.setDingTalkStatus(ret.data.dingTalkStatus)
                  this.$emit('setDingTalkStatus', ret.data.dingTalkStatus)
                  if(!ret.data.dingTalkStatus){
                    // 0 正常  
                    if(timer) clearInterval(timer);
                    this.setModalVisible(false)
                  } else if(ret.data.dingTalkStatus == 1) {
                    // 1未绑定钉钉 跳转到账号中心 进行绑定
                  } else {
                    // 2未加入部门
                    this.setModalVisible(true)
                    this.dingTalkStatusTimer();
                  }
              }
          } else {
              clearInterval(timer)
              this.$message.error(this.$getCodeMessage(ret.code, ret.message, ret.messageArgs) || this.$t('app.auto_688_d90ce707'))
          }
      }).catch( err => {
          clearInterval(timer)
          this.$message.error(this.$t('app.auto_688_d90ce707'))
      })
    }
  }
}
</script>
<style lang="scss">
.dd-modal-warp{
  width: 660px;
  height: 510px;
  border-radius: 12px;
  background: #FFFFFF url('../assets/images/dingding/bottom.png') no-repeat bottom !important;
  background-size: contain;
  .el-dialog__body{
      padding: 0;
      .modal-cont{
        position: relative;
        padding: 58px 40px 0;
        span{
          display: block;
          &.line{
            width: 20px;
            height: 1px;
            background: #333;
            margin: 40px 0;
          }
        }
        .cont{
          display: flex;
          align-items: center;
          justify-content: space-between;
          .left{
            width: 50%;
            align-self: flex-start;
            h2{
              font-size: 24px;
              font-weight: bold;
            }
            p{
              font-size: 16px;
              font-weight: 400;
            }
            ul{
              li{
                font-size: 18px;
                font-family: SourceHanSansCN-Medium, SourceHanSansCN;
                font-weight: 500;
                color: #333333;
                margin-bottom: 20px;
                &::before{
                  display: inline-block;
                  content: '';
                  width: 30px;
                  height: 30px;
                  vertical-align: middle;
                  margin-right: 20px;
                }
                &.light{
                  &::before{
                    background: url('../assets/images/dingding/light.png') no-repeat;
                    background-size: contain;
                  }
                }
                &.student{
                  &::before{
                    background: url('../assets/images/dingding/student.png') no-repeat;
                    background-size: contain;
                  }
                }
                &.promote{
                  &::before{
                    background: url('../assets/images/dingding/promote.png') no-repeat;
                    background-size: contain;
                  }
                }
              }
            }
          }
          .right{
            width: 50%;
            .logo{
              width: 80px;
              height: 80px;
              margin: 0 auto;
              img{
                display: block;
                width: 100%;
              }
            }
            .line{
              margin: 20px auto;
            }
            .btn{
              width: 180px;
              height: 36px;
              line-height: 36px;
              text-align: center;
              margin: 0 auto;
              color: #FFFFFF;
              background: #0076FE;
              box-shadow: 0px 3px 6px 0px rgba(0,118,254,0.2900);
              border-radius: 18px;
              opacity: .8;
              cursor: pointer;
              &:hover{
                opacity: 1;
              }
            }
            &.qrcode{
              width: 250px;
              height: 360px;
              background: #FFFFFF;
              box-shadow: 0px 0px 12px 0px rgba(0,0,0,0.1200);
              border-radius: 8px;
              margin-top: 32px;
              .logo{
                width: 219px;
                height: 212px;
                margin: 16px auto;
                background: #FFFFFF url('../assets/images/dingding/qr_warp.png') no-repeat bottom;
                background-size: contain;
                padding: 10px;
                img{
                  display: block;
                  width: 100%;
                }
              }
              .txt{
                text-align: center;
                font-size: 16px;
                color: #333;
              }
            }
          }
        }
      }
      .steps{
        position: absolute;
        left: 40px;
        bottom: 27px;
        .step{
          font-size: 16px;
          font-weight: 400;
          color: rgba(255,255,255,0.9000);
          line-height: 24px;
          img{
            display: inline-block;
            width: 36px;
            height: 22px;
            margin-right: 10px;
          }
        }
      }
      .close{
        position: absolute;
        top: 26px;
        right: 26px;
        width: 26px;
        height: 26px;
        opacity: .8;
        cursor: pointer;
        img{
          display: block;
          width: 100%;
        }
        &:hover{
          opacity: 1;
        }
      }
      .is-error{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        text-align: center;
        .txt{
          font-size: 20px;
          font-family: SourceHanSansCN-Normal, SourceHanSansCN;
          font-weight: 400;
          color: #666666;
          line-height: 30px;
        }
        .error-img{
          width: 80px;
          height: 80px;
          margin: 72px auto 36px;
          img{
            display: block;
            width: 100%;
          }
        }
      }
  }
}
.dd-modal-warp-after{
  height: auto;
  background: #fff;
  .el-dialog__body{
      .modal-cont{
        padding: 24px 40px;
        .after-bind{
          width: 100%;
          display: inline-block;
          .warp{
            display: flex;
            align-items: center;
            justify-content: space-around;
          }
          h2{
            width: 100%;
            text-align: center;
            font-size: 24px;
            margin-bottom: 0;
          }
          .left,.right{
            width: auto;
            .qrcode{
              width: 250px;
              height: 310px;
              background: #FFFFFF;
              box-shadow: 0px 0px 12px 0px rgba(0,0,0,0.1200);
              border-radius: 8px;
              margin-top: 24px;
              padding: 2px;
              .logo{
                width: 219px;
                height: auto;
                margin: 16px auto 26px;
                img{
                  display: block;
                  width: 100%;
                }
              }
              .txt{
                text-align: center;
                margin-bottom: 24px;
              }
            }
            .study-btn{
              width: 110px;
              height: 34px;
              line-height: 34px;
              margin: 0 auto 32px;
              color: #fff;
              background: #F4840F;
              border-radius: 18px;
              text-align: center;
              cursor: pointer;
            }
          }
        }
      }
    }
}
</style>